import React from 'react';
import { motion } from 'framer-motion';
export function Reframe() {
  return <section className="py-32 bg-teal-900 text-cream text-center px-6 relative overflow-hidden" data-id="element-147">
      {/* Subtle background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-teal-800/40 rounded-full blur-3xl -translate-y-1/2 pointer-events-none" data-id="element-148"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-149">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-terracotta text-sm font-semibold tracking-widest uppercase mb-12" data-id="element-150">
          Y quiero decirte algo importante:
        </motion.p>

        <div className="space-y-6 font-serif text-4xl md:text-5xl lg:text-6xl leading-tight" data-id="element-151">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-152">
            No naciste para vivir así.
          </motion.h2>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} data-id="element-153">
            En ansiedad. Naciste para volver a ti.
          </motion.h2>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="text-gold italic" data-id="element-154">
            Y sí, puedes reconstruirte emocionalmente.
          </motion.h2>
        </div>
      </div>
    </section>;
}